import { NgModule } from '@angular/core';

import { CommonSecondsFormatterPipe } from './seconds_formatter.pipe';
import { CommonTwoDigitsNumberPipe } from './two_digits_number.pipe';
import { CommonDateFormatter } from './date_formatter.pipe';
import { CommonNAFormatter } from './na_formatter.pipe';
import { CommonNAToBlankFormatter } from './na_blank_formatter.pipe';
import { CommonCapitalizeFormatter } from './capitalize_formatter.pipe';
import { CommonPrettyNumberPipe } from './pretty_number.pipe';
import { CommonPercentPipe } from './common_percent_formatter.pipe';
import { CommonNumberWithUnitsFormatterPipe } from './common_number_with_units_formatter.pipe';
import { CommonEscapedBracketReplace } from './escape_bracket_replace.pipe';
import { CommonExtensionFormatterPipe } from './extension_formatter.pipe';
import { CommonPassportNumberFormatterPipe } from './passport_number_formatter.pipe';
import { CommonSubdivisionCodeFormatterPipe } from './subdivision_code_formatter.pipe';
import { CommonPrettyPhoneNumber } from './common_pretty_phone_number.pipe';
import { CommonVersionFormatterPipe } from './version_formatter.pipe';

@NgModule({
	declarations: [
		CommonSecondsFormatterPipe,
		CommonTwoDigitsNumberPipe,
		CommonEscapedBracketReplace,
		CommonDateFormatter,
		CommonNAFormatter,
		CommonNAToBlankFormatter,
		CommonCapitalizeFormatter,
		CommonPrettyNumberPipe,
		CommonPercentPipe,
		CommonNumberWithUnitsFormatterPipe,
		CommonExtensionFormatterPipe,
		CommonPassportNumberFormatterPipe,
		CommonSubdivisionCodeFormatterPipe,
		CommonPrettyPhoneNumber,
		CommonVersionFormatterPipe,
	],
	providers: [
		CommonSecondsFormatterPipe,
		CommonTwoDigitsNumberPipe,
		CommonEscapedBracketReplace,
		CommonDateFormatter,
		CommonNAFormatter,
		CommonNAToBlankFormatter,
		CommonCapitalizeFormatter,
		CommonPrettyNumberPipe,
		CommonPercentPipe,
		CommonNumberWithUnitsFormatterPipe,
		CommonExtensionFormatterPipe,
		CommonPassportNumberFormatterPipe,
		CommonSubdivisionCodeFormatterPipe,
		CommonPrettyPhoneNumber,
		CommonVersionFormatterPipe,
	],
	exports: [
		CommonSecondsFormatterPipe,
		CommonTwoDigitsNumberPipe,
		CommonEscapedBracketReplace,
		CommonDateFormatter,
		CommonNAFormatter,
		CommonNAToBlankFormatter,
		CommonCapitalizeFormatter,
		CommonPrettyNumberPipe,
		CommonPercentPipe,
		CommonNumberWithUnitsFormatterPipe,
		CommonExtensionFormatterPipe,
		CommonPassportNumberFormatterPipe,
		CommonSubdivisionCodeFormatterPipe,
		CommonPrettyPhoneNumber,
		CommonVersionFormatterPipe,
	],
})
export class CommonPipesModule {}
